import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Accordion, Button } from "react-bootstrap";
import { FaPen } from "react-icons/fa";
import { isInternal, isLenderRole, isProjectReadOnlyRole, isProjectRole, isReadonlyRole, isTPORole } from "../../../redux/actions/userAction";
import ContextAwareToggle from "../../Profile/ContextAwareToggle";
import { fetchReviewers } from "../../shared/services/LenderRequestService";
import { AssignReviewerModal } from "../AssignReviewer/AssignReviewerModal";
import { DocumentItem } from "./DocumentItem/DocumentItem";
import RequestDetailsModal from "./RequestDetailsModal/RequestDetailsModal";
import "./RequestFeed.css";
import { RequestHistoryItem } from "./RequestHistoryItem/RequestHistoryItem";
import { WarningOutlined } from "@material-ui/icons";
import { buildRequestFieldDefs } from "../../../redux/actions/lenderRequestActions";
import { useDispatch } from "react-redux";
import { REQUEST_STATUSES } from "../../shared/constants/RequestStatuses";
import CommunicationFeed from "./CommunicationFeed/CommunicationFeed";



const RequestFeed = ({ requests, projectInfo, projectRestrictions, onRefresh }) => {
  const [reviewers, setReviewers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalInitialized, setModalInitialized] = useState(false);

  const dispatch = useDispatch();  

  useEffect(() => {
    dispatch(buildRequestFieldDefs());
    
    if (isInternal()) {
      (async function () {
        try {
          setLoading(true); // Set loading to true before fetching data
          let reviewersList = await fetchReviewers();
          // Sort the requestList alphabetically by a property userName
          reviewersList = reviewersList.sort((a, b) => {
            const nameA = a.userName?.toLowerCase() || ""; 
            const nameB = b.userName?.toLowerCase() || "";
            return nameA.localeCompare(nameB);
          });
          setReviewers(reviewersList);
  
          setModalInitialized(true);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false); // Set loading to false after data is fetched
        }
      })();
    }
  }, []); 

  const downloadFile = (docMapId, fileName) => {
    axios
      .get(
        global.REACT_APP_API_ENDPOINT + `/docStorage/downloadFile/${docMapId}`,
        {
          headers: { "Access-Control-Allow-Origin": "*" }
        }
      )
      .then((response) => {
        if (response?.data?.fileUrl) {
          const url = response.data.fileUrl;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName || "document");
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  function RequestHeaderInfo({modalInitialized, reviewers, item, onRefresh }) {
    const [showDetailsModal, setShowDetailsModal] = useState(false);    
    const [showAssignModal, setShowAssignModal] = useState(false); 
    
    const alertAdditionalDocs = (isLenderRole() || isTPORole()) && !isReadonlyRole() && item.externalStatus === REQUEST_STATUSES.ADDITIONAL_INFORMATION_REQUIRED;

    const openDetailsModal = e => {
      e?.stopPropagation();
      setShowDetailsModal(true);
    };

    return (
      <div className="request-stack">
        <Accordion defaultActiveKey="0">
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px' }}>
            <div style={{ marginTop: '4px' }}>
              <ContextAwareToggle eventKey="1" />
            </div>
            <div className="request-info">
              <div className="request-prop">
                <div className="request-prop-header">Request Type</div>
                <div className="request-prop-value">{item.requestTypeName}</div>
              </div>
              <div className="request-prop">
                <div className="request-prop-header">Requested By</div>
                <div className="request-prop-value">{item.requestCreatedByName || item.requestCreatedByLdapId}</div>
              </div>
              <div className="request-prop">
                <div className="request-prop-header">Lender</div>
                <div className="request-prop-value">{item.lenderName}</div>
              </div>
              <div className="request-prop">
                <div className="request-prop-header">Date</div>
                <div className="request-prop-value">{moment(item.requestCreatedDate).format("MM/DD/YY")}</div>
              </div>
              
              {(isInternal() || isProjectReadOnlyRole()) ? (
                
                <div className="request-prop">
                  <div className="request-prop-header">Assigned To</div>
                  <div className="request-prop-value">
                    {item.assignedToName || item.assignedToLdapId || "N/A"} {(isInternal() && !(item.statusName && (item.statusName.endsWith('Action Taken') || item.statusName.endsWith('Unresponsive')))) && (
                      <FaPen 
                        className="feed-edit-icon"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setShowAssignModal(true);
                        }} 
                      />
                    )}
                    {modalInitialized && (
                      <AssignReviewerModal 
                        selectedRequest={item} 
                        show={showAssignModal} 
                        setShow={setShowAssignModal}
                        reviewers={reviewers}
                        onAssignComplete={onRefresh}
                      />
                    )}
                  </div>
                </div>
              ) : (<></>)}
              <div className="request-prop">
                <div className="request-prop-header">Status</div>
                <div className={"request-prop-value " + (alertAdditionalDocs ? "warning" : "")}>
                  {/* {alertAdditionalDocs && (
                    <WarningOutlined className="warning-icon" />
                  )} */}
                  {(isInternal() || isProjectReadOnlyRole()) 
                    ? item.internalStatus 
                    : item.internalStatus === REQUEST_STATUSES.ADDITIONAL_INFORMATION_RECEIVED 
                      ? "Additional Information Submitted"
                      : item.externalStatus}
                </div>
              </div>
              <div className="view-details-cell">
                <Button className="btn-submit" onClick={openDetailsModal}>
                  Details
                </Button>
                <RequestDetailsModal
                  show={showDetailsModal}
                  onClose={() => setShowDetailsModal(false)}
                  request={item}
                  projectInfo={projectInfo}
                />
              </div>
            </div>
          </div>
          <Accordion.Collapse eventKey="1">
            <>
              <hr style={{margin: '16px 0', borderColor: '#edebe9'}} />
              <CommunicationFeed requestId={item.requestId} />
              <hr style={{margin: '16px 0', borderColor: '#edebe9'}} />
              <DocumentInfo item={item} />
              <hr style={{margin: '16px 0', borderColor: '#edebe9'}} />
              <ActivityInfo item={item} />
            </>
          </Accordion.Collapse>
        </Accordion>
      </div>
    );
  }

  function DocumentInfo({ item }) { 
    const documents = item.requestFeedDocumentDTOList || [];

    return (
      <div className="request-stack">
        <Accordion defaultActiveKey="0">
          <ContextAwareToggle eventKey="1">
            <p className="request-stack-header accordion-header-title">Documents</p>
          </ContextAwareToggle>
          <Accordion.Collapse eventKey="1">
            <div className="request-stack-list documents-stack-list">
              {documents.map((docItem, i) => (
                <DocumentItem key={i} docItem={docItem} />
              ))}
            </div>
          </Accordion.Collapse>
        </Accordion>
      </div>
    );
  }

  function ActivityInfo ({ item }) {
    const changeLog = item.requestFeedActivityTrackerDTOList || [];

    return (
      <div className="request-stack">
        <Accordion defaultActiveKey="0">
          <ContextAwareToggle eventKey="1">
            <p className="request-stack-header accordion-header-title">Activity</p>
          </ContextAwareToggle>
          <Accordion.Collapse eventKey="1">
            <div className="request-stack-list">
              {changeLog.map((eventItem, i) => (
                <React.Fragment key={i}>
                  {i > 0 ? <hr style={{margin: '8px 0'}} /> : <></>}
                  <RequestHistoryItem 
                    eventItem={eventItem} 
                    externalStatus={(!isInternal() && !isProjectReadOnlyRole() && eventItem.isEscalated) ? item.externalStatus : undefined}
                  />
                </React.Fragment>
              ))}
            </div>
          </Accordion.Collapse>
        </Accordion>
      </div>
    );
  }

  return (
    <>
    {requests.map((item, i) => {
      // Prepare per-request arrays inside the map
      const changeLog = item.requestFeedActivityTrackerDTOList || [];
      const documents = item.requestFeedDocumentDTOList || [];
      // Notes: use activity notes for now
      const notes = changeLog.filter(act => act.notes).map(act => ({
        user: act.createdByName || act.createdByLdapId,
        dateCreated: act.createdDate || null,
        comment: act.notes
      }));
      return (      
        <div className="request-list-item" key={i}>
          <RequestHeaderInfo

            item={item}
            // TEMP: TESTING ONLY
            // item={{
            //   ...item,
            //   requestTypeName: "Remove Unavailable Status", // temp
            //   // requestTypeName: "Add Unavailable Status", // temp
            //   // requestTypeName: "Remove Approved by Fannie Mae Status", // temp
            //   // requestTypeName: "Risk Review Required", // temp

            //   reasonCodeDTOList: [{
            //     "reasonId": 104,
            //     "reasonCode": "Audit Test",
            //     "reasonDefinitionInternal": "xyz",
            //     "reasonDefinitionExternal": "update reason codw",
            //     "severity": 300,
            //     "statusType": "Unavailable",
            //     "createdBy": "r0usct",
            //     "updatedBy": "r0usct",
            //     "createdDate": 1713972983278,
            //     "updatedDate": 1713973057050,
            //     "active": false
            //   }, {
            //     "reasonId": 141,
            //     "reasonCode": "Not active2",
            //     "reasonDefinitionInternal": "test internal enhancement",
            //     "reasonDefinitionExternal": "testing enhancement",
            //     "severity": 202,
            //     "statusType": "Unavailable",
            //     "createdBy": "g4umcn",
            //     "updatedBy": "r0usct",
            //     "createdDate": 1714453351113,
            //     "updatedDate": 1714755020866,
            //     "active": true
            //   }]
            // }}

            
            modalInitialized={modalInitialized}
            reviewers={reviewers}
            documents={documents}
            changeLog={changeLog}
            projectRestrictions={projectRestrictions}
            onRefresh={onRefresh}
          />
        
        </div>
      );
    })}
  </>
  );
};

export default RequestFeed;